module.exports = __webpack_public_path__ + "static/img/solutionDetailPic7.7848228.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic7.jpg
// module id = CWxh
// module chunks = 1